import React from 'react';

const EditModule = ({ children, className }) => {
  return <div className={`edit__module ${className}`}>{children}</div>;
};

export default EditModule;
